import { api } from "../api";

/**
 * commandFindAllExportResponse - Function that finds on database all commands and export in a PDF/XSLX file  
 * /commands/${status}/{exporttype}    
 * method GET  
 * @async-function
 */
const commandFindAllExportResponse = async (token: string, managerId: number, status: string,  exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/commands/${managerId}/${status}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default commandFindAllExportResponse;